export enum RowLinkRelation {
    PARENT = 'parent',
    PREDECESSOR = 'predecessor',
}

export enum StatementUriExtension {
    AFTER = "after",
}
